import FeatureCard from "../feature-card/feature-card";
import ScrollContainer from "react-indiana-drag-scroll";
import styles from "./faculty.module.scss";
import { useState, useRef } from 'react';

export default function Faculty({
  description,
  teachers,
  isDesktop,
  style: parentStyle,
  type,
}) {
    
  const [scrollStyle, setScrollStyle] = useState({
    left: 50,
    right: 50
  })
  const [scrollWidthState, setScrollWidthState] = useState(null)
  const dragableRef = useRef(null);
  return (
    <div id={type == 'retreats' ? 'teachers' : 'faculty'} className={styles.faculty} style={parentStyle}>
      <p className={styles.title}>Our {type == 'retreats' ? 'Teachers' : 'Faculty'}</p>

      <ScrollContainer 
        ref={dragableRef}
        vertical={false} 
        className={styles.content} 
        style={{
          paddingLeft: scrollStyle.left, 
          paddingRight: scrollStyle.right,
          transition: 'all 0.5s ease'
        }}
        onScroll={(scrollLeft, scrollTop, scrollWidth, scrollHeight)=>{
          if(scrollWidthState === null) {
            setScrollWidthState(scrollWidth)
          }
          if(scrollLeft === 0) {
            setScrollStyle({
              left: 200,
              right: 50
            })
          } else if(scrollWidth - parseInt(scrollLeft) == dragableRef.current.container.current.clientWidth 
          && scrollWidth === scrollWidthState){
            console.log('masuk')
            setScrollStyle({
              left: 50,
              right: 200
            })
            
          }
        }}
        onEndScroll={()=>{
          console.log('keluar')
          setScrollStyle({
            left: 50,
            right: 50
          })
        }}
      >
        {description && (
          <div className={styles.description}>
            <p>{description}</p>
          </div>
        )}

        {teachers?.map((teacher, i) => (
          <div className={styles.card} key={i}>
            <FeatureCard
              key={teacher.slug}
              feature={{
                subtitle: teacher.name,
                description: teacher.short_description,
                media: [teacher.featured_image],
                link: `/about/teachers/${teacher.slug}`,
              }}
              mediaHeight={isDesktop ? 580 : 480}
            ></FeatureCard>
          </div>
        ))}
      </ScrollContainer>
    </div>
  );
}
